import React from "react";
import SVG from "./SVG";

const LetterSIcon: React.FunctionComponent<{}> = props => (
  <SVG viewBox="0 0 768 768" {...props}>
    <path d="m360 45c-99.411 0-180 80.589-180 180s80.589 180 180 180c49.706 0 90 40.294 90 90s-40.294 90-90 90-90-40.294-90-90h-90c0 99.411 80.589 180 180 180s180-80.589 180-180-80.589-180-180-180c-49.706 0-90-40.294-90-90s40.294-90 90-90 90 40.294 90 90h90c0-99.41-80.59-180-180-180z"></path>
  </SVG>
);

export default LetterSIcon;
